<div class="modal-body">
            <app-start-kit-chooser
                [productLineCode]="productLineCode"
                [kidTeen]="kidTeen"
                (resultChange)="setAndDestroy(orderItem, customerNo,newOrderSelected, $event)"
            ></app-start-kit-chooser>
</div>
